import React from 'react';
import { Switch } from 'react-router-dom';

import { createRelativeRoute } from 'component/RelativeRoute/RelativeRoute';
import { AppRoute } from 'app/route/app';
import { renderRoutes } from 'router/components/renderRoutes';
import { useFetchUser } from 'router/hooks/useFetchUser';
import { useClearDepartments } from 'shared/hooks/useClearDepartments';
import { useClearEngagementDrivers } from 'shared/hooks/useClearEngagementDrivers';
import { useInitializePostHog } from 'shared/hooks/useInitializePostHog';
import { useInitializeIntercom } from 'shared/hooks/useInitializeIntercom';
import { useInitializeRUM } from 'shared/hooks/useInitializeRUM';
import { useInitializeDataDogLogs } from 'shared/hooks/useInitializeDataDogLogs';

import { useAppRoutes } from './useAppRoutes';

const RelativeRoute = createRelativeRoute(AppRoute.HOME);

export const AppRoutes: React.FC = () => {
  const routes = useAppRoutes();

  useInitializeRUM();
  useInitializeDataDogLogs();
  useFetchUser();
  useInitializePostHog();
  useInitializeIntercom();
  useClearDepartments();
  useClearEngagementDrivers();

  return <Switch>{renderRoutes({ RelativeRoute, routes })}</Switch>;
};
